import ApiClient from './ApiClient'

export default class TutorService {

    constructor() {
        this.apiClient = new ApiClient();
    }

    addQualification(qualification) {
        return this.apiClient.createAuthed().post('tutorqualifications', qualification);
    }

    deleteQualification(id) {
        return this.apiClient.createAuthed().delete(`tutorqualifications/${id}`);
    }

    sortQualifications(qualificationIds) {
        return this.apiClient.createAuthed().post('tutorqualifications/sort', qualificationIds);
    }

    addLocation(location) {
        return this.apiClient.createAuthed().post('tutorlocations', location);
    }

    deleteLocation(id) {
        return this.apiClient.createAuthed().delete(`tutorlocations/${id}`);
    }

    updateSubjectsTaught(subjectsTaught) {
        return this.apiClient.createAuthed().post('tutorsubjects', subjectsTaught);
    }

    submitSubjectSuggestion(suggestion) {
        return this.apiClient.createAuthed().post('tutorsubjects/suggestion', suggestion);
    }

    get(tutorId, allowIncomplete) {
        return this.apiClient.create().get(`tutor/${tutorId}?allowIncomplete=${allowIncomplete || false}`);
    }

    canAcceptPayments(publicTutorId) {
        return this.apiClient.create().get(`tutor/${publicTutorId}/accepts-payments`)
    }

    uploadQualification(file) {
        const formData = new FormData()
        formData.append('file', file)

        return this.apiClient.createAuthed().post(
            'tutorqualifications/uploadproof',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
    }

    saveTestimonial(testimonial) {
        return this.apiClient.createAuthed().post('tutortestimonials', testimonial);
    }

    deleteTestimonial(id) {
        return this.apiClient.createAuthed().delete(`tutortestimonials/${id}`);
    }

    sortTestimonials(ids) {
        return this.apiClient.createAuthed().post('tutortestimonials/sort', ids);
    }

    saveArticle(article) {
        return this.apiClient.createAuthed().post('tutorarticles', article)
    }

    submitInterviewAvailability(dates) {
        return this.apiClient.createAuthed().post('tutorinterview', dates)
    }

}